import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'
import { cacheManager } from '../utils/CacheManager'

// Configure request setup
const serviceName = 'ConversationChannelService'
const host = servicesConfig.Conversations
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const ConversationChannelService = {
  fetchCustomConversationChannels: (locationId: string) => {
    const query = `?locationId=${locationId}&type=custom`
    return cacheManager.getCachedData(`custom-conversation-channels`, () => 
      request().get('/providers/search' + query).then(responseBody), {
        key: `custom-conversation-channels-${locationId}`
      })
  },

  fetchCustomConversationChannelsAndUpdateCache: (locationId: string) => {
    cacheManager.clearCache(`custom-conversation-channels`)
    return ConversationChannelService.fetchCustomConversationChannels(locationId)
  },

  fetchDefaultConversationChannels: (locationId: string) => {
    const query = `?locationId=${locationId}&type=defaults`
    return cacheManager.getCachedData(`default-conversation-channels`, () => 
      request().get('/providers/search' + query).then(responseBody), {
        key: `default-conversation-channels-${locationId}`
      })
  }
}

export default ConversationChannelService
